
import React, { useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';

import {  getCurrentDateTime, formatDateMoment } from "../../../../utils/utils"
import { selectCurrentCycle,selectFollowCycle,selectPatientInfo,selectCoaInfo } from "../../../slices/common";
import { useSelector } from "react-redux";
import {capitalizeWords} from "../../../../utils/utils"

const BatchReleaseCertificate = ({open, onClose, isVisible=false }) => {
   const printContentRef = useRef(null);
     const currentCycle = isVisible ? useSelector(selectFollowCycle) : useSelector(selectCurrentCycle)
     const patient = useSelector(selectPatientInfo)
     const coaForm =  useSelector(selectCoaInfo)
   const topLevel = patient?.data?.patient_information?.print_details?.find((it) => it?.label_type == '7')
  const topLogo = topLevel?.brand_logo;
   const address = topLevel?.org_description || '22WJ+JV7, S Central Rd, MIDC Industrial Area, Shiravane, Nerul, Navi Mumbai, Maharashtra 400705, www.immunoact.com';
  const brand_name = topLevel?.brand_name;
   const reactToPrintFn = useReactToPrint({
     content: () => printContentRef.current,
     onAfterPrint: onClose,
     removeAfterPrint: true,
   });
   const phaseType = patient?.data?.phase_type;
   const context  = phaseType == 'Commercial'  ? ' Commercial medicinal product' : ' Investigational medicinal product'
     useEffect(() => {
       if (open) {
         const timer = setTimeout(() => {
           if (printContentRef.current) {
             reactToPrintFn();
           }
         }, 300);
         
         return () => clearTimeout(timer);
       }
     }, [open]);
  return (
    <div style={{ display: isVisible?'block':'none' }}>
      <div ref={printContentRef}>
      <div style={{ 
        width: '210mm',
        minHeight: '297mm',
        padding: '15mm',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        fontSize: '10pt',
        backgroundColor: 'white',
        lineHeight: '1.2',
        boxSizing: 'border-box',
        position: "relative"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#2E5598',
            marginBottom: '5px',
            textAlign: "center",
            display: "flex",
            flexDirection: "column"
          }}>
           <img src={topLogo}  style={{margin:"0 auto", maxWidth:"200px",maxHeight: "100px"}} />
           {brand_name}
          </div>
          <div style={{
            fontSize: '11px',
            color: '#777',
            lineHeight: '1.4'
          }}>
            {address}
           
          </div>
          <div style={{
            borderTop: '2px solid #D8D8D8',
            margin: '15px 0',
            width: '100%'
          }}></div>
          
          {/* Form Title */}
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#000',
            margin: '10px 0'
          }}>
           Batch Release certificate
          </div>
        </div>
        
        <div style={{ paddingBottom: '50px' }}> {/* Add padding to prevent content overlap with footer */}
              <div>
                {/* Section title */}
                <div className="section-title">Product Information</div>
                
                {/* Rounded box */}
             <div className="section-box">
  <div className="field-grid">
    <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Product Name</div>
      <div className="field-value">
        {patient?.data?.product_name || ""}
      </div>
    </div>
    <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Batch Number</div>
      <div className="field-value">
        {currentCycle?.batch_no || ""}
      </div>
    </div>
     <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Manufacturing Date</div>
      <div className="field-value">
       {formatDateMoment(currentCycle?.mfg_at) || ""}
      </div>
    </div>
      <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Expiry Date</div>
      <div className="field-value">
       {coaForm?.expired_at || ""}
      </div>
    </div>
    <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Mfg. Dose (If required)</div>
      <div className="field-value">
       {currentCycle?.car_t_dose_per_kg ? currentCycle?.car_t_dose_per_kg +' Kg':''}
      </div>
    </div>
      <div className="field-item" style={{ gridColumn: 'span 1' }} >
      <div className="field-label">Storage Condition</div>
      <div className="field-value">
       {coaForm?.storage_condition || ""}
      </div>
    </div>
  </div>
</div>
 <div className="section-title">Result of Analysis</div>
       <div className="section">
   <p>
          Result complies as per Specification No.{" "}
          {coaForm?.specification_no} Refer Attached Certificate of Analysis
          for Details.
        </p>
      </div>

      {/* CART Commercial */}
        <p className="paragraph">
          “I hereby Certify that the above information is authentic and accurate.
          This batch of product has been Manufactured at the Immunoadoptive Cell
          Therapy Pvt Ltd. in full compliance with the cGMP requirements of the
          local regulatory Authority and with the product specification file
          for {context}.
          The batch manufacturing and analysis record were reviewed and found
          to be in compliance with GMP”.
        </p>
      </div>
  <div className="section-title mt-20">Comment/Remark (if any)</div>
  <div className="section-box">
  <div className="field-grid">{coaForm?.qa_remarks}</div>
  </div>
              </div>
        

   <div className="date-section">
            <div className="date-row">
              {/*<div className="date-column">
                <div className="date-label">Submitted By:</div>
                <div className="date-name">{coaForm?.prepared}({coaForm?.partially_approved_role})</div>
                <div className="date-time">{getCurrentDateTime(coaForm?.partially_approved_at)}</div>
              </div>
              
              <div className="date-column">
                <div className="date-label">Reviewed By:</div>
                <div className="date-name">{coaForm?.reviewed}({coaForm?.lead_approved_role})</div>
                <div className="date-time">{getCurrentDateTime(coaForm?.approved_lead_at)}</div>
              </div>*/}
              
              <div className="date-column">
                <div className="date-label">Approved By:</div>
                <div className="date-name">{capitalizeWords(coaForm?.approved_by)}{coaForm?.approved_role ? '('+coaForm?.approved_role+')':''}</div>
                <div className="date-time">{coaForm?.approved_at ? getCurrentDateTime(coaForm?.approved_at):''}</div>
              </div>
            </div>
          </div>

        </div>
         
        {/* Fixed Footer at bottom of last page */}
        <div className="footer-section"
  style={
    isVisible
      ? {} // do NOT add bottom when isVisible is true
      : { bottom: '15mm' }
  }>
          <div className="footer-content">
            <div className="declaration-text">
              This document is system generated and does not require a signature.
            </div>
          </div>
          <div className="timestamp-section">
            <span className="timestamp-item">
              Printed on: {getCurrentDateTime()}
            </span>
            <span className="timestamp-item">
              Created On: {coaForm?.created_at ? getCurrentDateTime(coaForm?.created_at):''}
            </span>
          </div>
        </div>
              
      <style>
        {`
          @page {
            size: A4;
            margin: 2mm;
          }
          
          .page-break {
            page-break-before: always;
            break-before: page;
          }
          
          .print-page {
            font-family: Arial, sans-serif;
            font-size: 14px;
            color: #000;
          }
          
          .head-title {
            text-align: center;
            font-weight: bold;
            color: #3571FF;
            font-size: 25px;
          }
          
          .section-title {
            font-size: 14px;
            font-weight: 700;
            padding: 11px 8px 11px;
            letter-spacing: 0.5px;
            background-color: #EAEBEF;
            border-radius: 10px 10px 0 0;
            margin-bottom: 0;
            border: 1px solid #D8D8D8;
            border-bottom: none;
          }
          
          .section-box {
            background: #f8fafc;
            padding: 16px;
            margin-bottom: 20px;
            border: 1px solid #D8D8D8;
            border-top: none;
            border-radius: 0 0 4px 4px;
          }
          
          .field-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px 24px;
          }
          
          .field-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          
          .field-item.full-width {
            /* This class is kept for backward compatibility */
          }
          
          .field-label {
            font-weight: 600;
            color: #333;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }
          
          .field-value {
            color: #545454;
            background: #ffffff;
            font-size: 12px;
            min-height: 15px;
            word-break: break-word;
          }
          
          .field-value.full-width-value {
            width: 100%;
          }
          
          /* Footer styles */
          .footer-section {
            position: absolute;
            left: 15mm;
            right: 15mm;
            margin-top: auto;
          }
          
          .footer-content {
            text-align: center;
            color: #858585;
            font-size: 10px;
            line-height: 1.4;
            margin-bottom: 5px;
          }
          .date-row {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-top:30px;
          }
            .paragraph {
            margin-top: 8px;
            text-align: justify;
            font-style: italic;
            padding:3px;
            color:#333
          }
            .date-label{
            color:#3571FF;
            font-size:10px;
            }
            .date-time{
            color:#A3A3A3;
             font-size:8px;
            }
              .date-name {
            font-size: 11px;
            margin-bottom: 4px;
            color: #545454;
          }
          .declaration-text {
            margin-bottom: 3px;
          }
          
          .confidential-text {
            font-style: italic;
          }
          
          .timestamp-section {
            display: flex;
            justify-content: space-between;
            font-size: 10px;
            color: #858585;
            border-top: 1px solid #e0e0e0;
            padding-top: 5px;
          }
          
          @media print {
            .footer-section {
              position: fixed;
              bottom: 15mm;
              left: 15mm;
              right: 15mm;
            }
            .section{
            padding:6px;
            }
            .field-value {
              background: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

      .line {
        display: inline-block;
        border-bottom: 1px solid #000;
        width: 200px;
        margin-left: 5px;
      }
            .section-box {
              background: #f8fafc !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-title {
              background-color: #EAEBEF !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
              .mt-20{
              margin-top:20px;
              }
          }
        `}
      </style>
    </div>
    </div>
  );
};

export default BatchReleaseCertificate;